module.exports = __webpack_public_path__ + "img/cave14.37f542cf.jpg";